import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoAtlassian = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 179 48"
    {...props}
  >
    <g clipPath="url(#Logo_Atlassian_svg__a)">
      <path
        fill="url(#Logo_Atlassian_svg__b)"
        d="M7.063 22.034a.618.618 0 0 0-1.052.114L.68 32.805a.637.637 0 0 0 .57.922h7.422a.61.61 0 0 0 .57-.352c1.6-3.308.63-8.339-2.18-11.341"
      />
      <path
        fill="#2684FF"
        d="M10.972 12.34a14.06 14.06 0 0 0-.82 13.878l3.577 7.156a.64.64 0 0 0 .57.352h7.42a.637.637 0 0 0 .57-.922s-9.983-19.969-10.234-20.468a.601.601 0 0 0-1.083.004"
      />
      <path
        fill="#0052CC"
        d="M98.013 20.886c0 2.639 1.224 4.734 6.012 5.659 2.857.6 3.455 1.06 3.455 2.013 0 .925-.599 1.523-2.612 1.523a14.74 14.74 0 0 1-6.937-1.877v4.298c1.442.708 3.346 1.497 6.883 1.497 5.006 0 6.992-2.233 6.992-5.55zm13.793 7.563c0-3.129-1.659-4.598-6.339-5.605-2.584-.571-3.21-1.142-3.21-1.958 0-1.033.925-1.47 2.639-1.47 2.068 0 4.108.626 6.04 1.497v-4.108a13.66 13.66 0 0 0-5.904-1.225c-4.625 0-7.02 2.014-7.02 5.306M162.325 15.852v17.874h3.809v-13.63l1.605 3.618 5.387 10.012h4.788V15.852h-3.809v11.535l-1.442-3.346-4.326-8.19zM138.1 15.852h-4.163v17.874h4.163zM129.134 28.449c0-3.129-1.659-4.598-6.339-5.605-2.584-.571-3.21-1.142-3.21-1.958 0-1.033.925-1.47 2.639-1.47 2.068 0 4.108.626 6.04 1.497v-4.108a13.65 13.65 0 0 0-5.904-1.225c-4.625 0-7.019 2.014-7.019 5.306 0 2.639 1.224 4.734 6.012 5.659 2.857.6 3.455 1.06 3.455 2.013 0 .925-.599 1.523-2.611 1.523a14.74 14.74 0 0 1-6.938-1.877v4.298c1.442.708 3.346 1.497 6.883 1.497 5.006 0 6.992-2.233 6.992-5.55M65.675 15.852v17.874h8.556l1.347-3.863h-5.713V15.852zM48.772 15.852v3.863h4.625v14.011h4.19V19.715h4.952v-3.863zM42.697 15.852h-5.491l-6.233 17.874h4.76l.884-3.01c2.176.639 4.49.639 6.666 0l.884 3.01h4.76zm-2.746 11.64a8.1 8.1 0 0 1-2.29-.33l2.29-7.8 2.291 7.804a8.1 8.1 0 0 1-2.29.326M88.982 15.852h-5.49l-6.234 17.874h4.761l.884-3.01c2.176.639 4.49.639 6.666 0l.884 3.01h4.761zm-2.746 11.64a8.1 8.1 0 0 1-2.29-.33l2.29-7.8 2.291 7.804a8.1 8.1 0 0 1-2.29.326M153.1 15.852h-5.491l-6.233 17.874h4.761l.884-3.01c2.176.639 4.49.639 6.667 0l.883 3.01h4.762zm-2.747 11.64a8.1 8.1 0 0 1-2.291-.33l2.291-7.8 2.291 7.804a8.1 8.1 0 0 1-2.291.326"
      />
    </g>
    <defs>
      <linearGradient
        id="Logo_Atlassian_svg__b"
        x1={9.984}
        x2={4.359}
        y1={23.679}
        y2={33.422}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0052CC" />
        <stop
          offset={0.923}
          stopColor="#2684FF"
        />
      </linearGradient>
      <clipPath id="Logo_Atlassian_svg__a">
        <path
          fill="#fff"
          d="M.615 0h178v48h-178z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoAtlassian;
